/** `sessionStorage` — yopiq rejimda yoki taqiqlangan bo'lsa murojaatning o'zi xato beradi. */
export function sessionStore(): Storage | null {
  try {
    return window.sessionStorage
  } catch {
    return null
  }
}
